import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '2020寻找城市匠星';

const route: RouteConfig = {
  path: '/20200424CSJX',
  name: '20200424CSJX',
  component: () => import('./Home.vue'),
  redirect: '/20200424CSJX/index',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'index',
      component: () => import('./First.vue'),
      name: '20200424CSJX/index',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      component: () => import('./Detail.vue'),
      name: '20200424CSJX/detail',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      component: () => import('./RelativeNews.vue'),
      name: '20200424CSJX/news',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rules',
      component: () => import('./Rules.vue'),
      name: '20200424CSJX/rules',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
